var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5039 6.62268H12.436V8.68774H4.5V34.6227H36.5V16.099H36.4823L36.5 8.68774H28.4492V6.62268H26.3812V8.68774H14.5039V6.62268ZM26.3812 10.7352H14.5039V12.7477H12.436V10.7352H6.56796V14.594L34.4233 14.5765V10.7352H28.4492V12.7477H26.3812V10.7352ZM6.56796 32.5752H34.4409V16.624L6.56796 16.6415V32.5752Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GreenCalendar.043fbfd7654501b55ad46d960ad97acc.svg";